export default {"src":"/_next/static/media/pair-4.e74d0012.svg","height":173,"width":631,"blurWidth":0,"blurHeight":0};